import React from 'react';
import { AuthProvider } from './Contexts/AuthContext';
import Routes from './Utils/Routes';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import styled from 'styled-components';
import { ProfileProvider } from './Contexts/UserProfileContext';
import { AdvertisersProvider } from './Contexts/AdvertisersContext';
import { AgencyProvider } from './Contexts/AgencyContext';

const EnvNotification = styled.div`
    width: 100%;
    border-top: 1px solid red;
    background-color: red;
    text-align: center;
    color: #fafbf7;
    font-weight: bold;
`;
const App = () => {
    const stripeTestPromise = loadStripe(process.env.REACT_APP_API_STRIPE_PUBLIC);
    const currentDomain = window.location.hostname;

    const isProd = currentDomain === 'app.davie.ai';
    const isDev = currentDomain === 'dev.davie.ai';
    const isStag = currentDomain === 'test.davie.ai';
    const isLocal = currentDomain === 'localhost';

    return (
        <>
            {isProd ? null : (
                <EnvNotification>
                    Environment: {isLocal ? 'Localhost' : null}
                    {isDev ? 'Development' : null}
                    {isStag ? 'Staging' : null}
                </EnvNotification>
            )}
            <AuthProvider>
                <ProfileProvider>
                    <AgencyProvider>
                        <AdvertisersProvider>
                            <Elements stripe={stripeTestPromise}>
                                <Routes />
                            </Elements>
                        </AdvertisersProvider>
                    </AgencyProvider>
                </ProfileProvider>
            </AuthProvider>
        </>
    );
};

export default App;
